/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiKeyDto } from '../models/api-key-dto';
import { authControllerDeleteAccount } from '../fn/auth/auth-controller-delete-account';
import { AuthControllerDeleteAccount$Params } from '../fn/auth/auth-controller-delete-account';
import { authControllerGetApiKey } from '../fn/auth/auth-controller-get-api-key';
import { AuthControllerGetApiKey$Params } from '../fn/auth/auth-controller-get-api-key';
import { authControllerLogin } from '../fn/auth/auth-controller-login';
import { AuthControllerLogin$Params } from '../fn/auth/auth-controller-login';
import { authControllerLoginRequestOtp } from '../fn/auth/auth-controller-login-request-otp';
import { AuthControllerLoginRequestOtp$Params } from '../fn/auth/auth-controller-login-request-otp';
import { authControllerMe } from '../fn/auth/auth-controller-me';
import { AuthControllerMe$Params } from '../fn/auth/auth-controller-me';
import { authControllerRefreshToken } from '../fn/auth/auth-controller-refresh-token';
import { AuthControllerRefreshToken$Params } from '../fn/auth/auth-controller-refresh-token';
import { authControllerRegister } from '../fn/auth/auth-controller-register';
import { AuthControllerRegister$Params } from '../fn/auth/auth-controller-register';
import { AuthUserDto } from '../models/auth-user-dto';
import { SessionDto } from '../models/session-dto';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authControllerMe()` */
  static readonly AuthControllerMePath = '/auth/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe$Response(params?: AuthControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthUserDto>> {
    return authControllerMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe(params?: AuthControllerMe$Params, context?: HttpContext): Observable<AuthUserDto> {
    return this.authControllerMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthUserDto>): AuthUserDto => r.body)
    );
  }

  /** Path part for operation `authControllerGetApiKey()` */
  static readonly AuthControllerGetApiKeyPath = '/auth/api-key';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerGetApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerGetApiKey$Response(params?: AuthControllerGetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyDto>> {
    return authControllerGetApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerGetApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerGetApiKey(params?: AuthControllerGetApiKey$Params, context?: HttpContext): Observable<ApiKeyDto> {
    return this.authControllerGetApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyDto>): ApiKeyDto => r.body)
    );
  }

  /** Path part for operation `authControllerRegister()` */
  static readonly AuthControllerRegisterPath = '/auth/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRegister$Response(params: AuthControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthUserDto>> {
    return authControllerRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRegister(params: AuthControllerRegister$Params, context?: HttpContext): Observable<AuthUserDto> {
    return this.authControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthUserDto>): AuthUserDto => r.body)
    );
  }

  /** Path part for operation `authControllerLoginRequestOtp()` */
  static readonly AuthControllerLoginRequestOtpPath = '/auth/login/otp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLoginRequestOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginRequestOtp$Response(params: AuthControllerLoginRequestOtp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authControllerLoginRequestOtp(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLoginRequestOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginRequestOtp(params: AuthControllerLoginRequestOtp$Params, context?: HttpContext): Observable<void> {
    return this.authControllerLoginRequestOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authControllerLogin()` */
  static readonly AuthControllerLoginPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin$Response(params: AuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return authControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin(params: AuthControllerLogin$Params, context?: HttpContext): Observable<SessionDto> {
    return this.authControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

  /** Path part for operation `authControllerRefreshToken()` */
  static readonly AuthControllerRefreshTokenPath = '/auth/refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerRefreshToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRefreshToken$Response(params: AuthControllerRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return authControllerRefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerRefreshToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerRefreshToken(params: AuthControllerRefreshToken$Params, context?: HttpContext): Observable<SessionDto> {
    return this.authControllerRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

  /** Path part for operation `authControllerDeleteAccount()` */
  static readonly AuthControllerDeleteAccountPath = '/auth/account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerDeleteAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerDeleteAccount$Response(params?: AuthControllerDeleteAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authControllerDeleteAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerDeleteAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerDeleteAccount(params?: AuthControllerDeleteAccount$Params, context?: HttpContext): Observable<void> {
    return this.authControllerDeleteAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
